import { curry, mergeAllWith } from 'lodash/fp'

import { keepRefCustomizer } from './mergeState'

const mergeStateAll = curry((targetObject, sourceObjects) => {
  return mergeAllWith(keepRefCustomizer, [{}, targetObject, ...sourceObjects])
})

export default mergeStateAll
